import Persistable from "../../storage/persistable";

export default class Rpi extends Persistable {}
